import axios from "axios";
import { API_HOST } from "../../consts/api_host";
import { getAccessToken } from "../clients/supabase";
import { getImpersonationHeaders } from "@/features/impersonation/impersonation-session";

type VerifyPhoneCodeResponse = {
  success?: boolean;
  error?: string;
};

export const verifyPhoneCode = async (body: {
  phoneNumber: string;
  code: string;
}): Promise<VerifyPhoneCodeResponse> => {
  try {
    const response = await axios.post<VerifyPhoneCodeResponse>(
      `${API_HOST}/phone/verify-code`,
      body,
      {
        headers: {
          Authorization: `Bearer ${await getAccessToken()}`,
          ...getImpersonationHeaders(),
        },
      },
    );
    return response.data;
  } catch (e) {
    if (axios.isAxiosError(e) && e.response?.data?.error) {
      return {
        error: e.response.data.error,
      };
    }
    return {
      error: "Error verifying code. Please try again.",
    };
  }
};
